import HasOriginalSourceObj from "./HasOriginalSourceObj";

export default class HasOriginalSourceObjList {
  constructor(name, initialValue, namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace) {
    this.namespace = namespace;
    this.name = name;
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.hasOriginalList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.hasOriginalList;
  }

  setObjList(fhasOriginalList) {
    this.hasOriginalList = fhasOriginalList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.hasOriginalList.length) {
      return;
    }
    this.hasOriginalList.splice(index, 1);
  }

  addValueObj(obj) {
    // console.log(obj);
    const hasOriginalSource = new HasOriginalSourceObj(this.name, obj, this.namespace, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.hasOriginalList.push(hasOriginalSource);
    // console.log(this.hasOriginalList);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.hasOriginalList.length; index++) {
      const listItem = this.hasOriginalList[index];
      expandedList.push(listItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.hasOriginalList.length; index++) {
      const listItem = this.hasOriginalList[index];
      condition = condition && listItem.isEmpty();
    }
    return condition;
  }
}
